import { type FC } from 'react';
import type { NodeProps } from 'reactflow';
import type { NodeData } from '@/types/node.types';
import BaseNode from './BaseNode';

const KPI_COLOR = '#14B8A6';

export const KPINode: FC<NodeProps<NodeData>> = ({ id, data, selected }) => {
  return <BaseNode id={id} data={data} color={KPI_COLOR} icon={'\u{1F4CA}'} selected={selected} />;
};

export default KPINode;
